export default __webpack_public_path__ + "static/media/62.d6c714d8.JPG";